import styled from 'styled-components';
import { ScreenSize } from '../../../enums';
import * as palette from '@mlc/mlc-palette';
import TrackableAnchor, {
	TrackableRoute,
} from '../../common/Anchor/TrackableAnchor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Ul = styled.ul`
	display: flex;
	justify-content: space-between;
	margin: 0;
	padding: 0;

	li:first-child {
		margin-left: 0;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		margin: 0;
		margin-bottom: 10px;
	}
`;

export const Li = styled.li`
	display: inline;
	margin-left: 22px;
`;

export const Anchor = styled(TrackableAnchor)`
	color: ${palette.mlcWhite};
	text-decoration: none;

	&:hover,
	&:active,
	&:focus {
		color: ${palette.mlcWhite};
		opacity: 1;
		text-decoration: underline;
	}
`;

export const Route = styled(TrackableRoute)`
	color: ${palette.mlcWhite};
	text-decoration: underline;

	&:hover,
	&:active,
	&:focus {
		color: ${palette.mlcWhite};
		opacity: 1;
		text-decoration: none;
	}
`;

export const FilterMenuIcon = styled(FontAwesomeIcon)`
	margin-right: 7px;
	margin-top: 4px;
`;
